import { render, staticRenderFns } from "./CambioPassword.vue?vue&type=template&id=2ad41f98&"
import script from "./CambioPassword.vue?vue&type=script&lang=js&"
export * from "./CambioPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports